import React from 'react';
import '../styles/About.css';

function About() {
  const cards = [
    {
      icon: '/1.png',
      colour: 'blue',
      title: 'Stop accidents before they happen',
      desc: 'Spot fatigue risks before they lead to incidents. Reaction times slow by 50% when people are tired. Zella catches it early.',
    },
    {
      icon: '/2.png',
      colour: 'green',
      title: "Your team's wellbeing, measured",
      desc: 'Show your commitment to employee wellbeing with evidence, not just policy documents.',
    },
    {
      icon: '/4.png',
      colour: 'orange',
      title: 'Boost productivity',
      desc: 'Well-rested employees are 13% more productive. Sleep-deprived teams perform as if legally impaired. The difference is measurable.',
    },
  ];

  return (
    <section className="about" id="about">
      <div className="section-container">
        <div className="section-header about-header">
          <span className="section-tag">Why Zella</span>
          <h2>Make fatigue visible. Make your workplace safer.</h2>
          <p className="section-subtitle">
            Zella combines a personal alertness app for your employees with a powerful insights
            dashboard for your organisation. Together, they turn invisible fatigue into actionable
            intelligence.
          </p>

        </div>

        <div className="about-grid">
          {cards.map(({ icon, colour, title, desc }) => (
            <div key={title} className={`about-card ${colour}`}>
              <div className="card-icon">
                <img src={icon} alt={title} className="card-icon-img" />
              </div>
              <h3 className={colour}>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
